export default __webpack_public_path__ + "fonts/SanFranciscoDisplay-Semibold.7d914eb7fcce5ccc30a420ff565134cc.ttf";